import type { ComponentType } from "react";
import type { SvgIconProps } from "@mui/material";
import { brandColors } from "../theme";

/** Wrap MUI icons for consistent brand purple in custom menu items etc. */
export const brandIconSx: SvgIconProps["sx"] = {
  color: brandColors.purple,
};

export const withBrandIcon = (Icon: ComponentType<SvgIconProps>) =>
  function BrandIcon(props: SvgIconProps) {
    return <Icon {...props} sx={{ ...brandIconSx, ...props.sx }} />;
  };
